import COMMON from './common';
import FORM_ERRORS from './form-errors';
import LOGIN_PAGE from './login-page';
import SUCCESS_MESSAGES from './messages/success-messages';
import ERROR_MESSAGES from './messages/error-messages';
import PROFILE_PAGE from './profile-page';
import TERMINAL_FORM from './terminal-form';
import COMPANY_FORM from './company-form';
import PLACE_FORM from './place-form';
import PRODUCT_FORM, { PRODUCT_FORM_VALIDATIONS } from './product-form';
import WEBSITE_FORM from './website-form';
import COMPANY_OWNER_FORM from './company-owner-form';
import NESTED_PRODUCT_FORM from './nested-product-form';
import PRODUCT_CATEGORY_FORM from './product-category-form';
import NESTED_PRODUCT_CATEGORY_FORM from './nested-product-category-form';
import PROMOTION_FORM from './promotion-form';
import LINK_ITEMS from './link-items';
import TABLE_HEADERS from './table-headers';
import MODAL from './modal';
import TYPES from './types';
import STATUS from './status';
import ORDER_VIEW from './order-view';

export const rs = {
    COMMON,
    FORM_ERRORS,
    ERROR_MESSAGES,
    LOGIN_PAGE,
    PROFILE_PAGE,
    TERMINAL_FORM,
    SUCCESS_MESSAGES,
    COMPANY_FORM,
    PLACE_FORM,
    PRODUCT_FORM,
    PRODUCT_FORM_VALIDATIONS,
    WEBSITE_FORM,
    COMPANY_OWNER_FORM,
    NESTED_PRODUCT_FORM,
    PRODUCT_CATEGORY_FORM,
    NESTED_PRODUCT_CATEGORY_FORM,
    PROMOTION_FORM,
    LINK_ITEMS,
    TABLE_HEADERS,
    MODAL,
    TYPES,
    STATUS,
    ORDER_VIEW,
};
